// Decorative SVG motifs inspired by Kumaoni Aipan folk-art
import React from "react";

export const AshtadalKamal = ({ className = "", stroke = "#b8452c", size = 120 }) => (
  <svg viewBox="0 0 120 120" width={size} height={size} className={className} fill="none" stroke={stroke} strokeWidth="1.5">
    <circle cx="60" cy="60" r="6" fill={stroke} />
    {Array.from({ length: 8 }).map((_, i) => {
      const a = (i * Math.PI) / 4;
      const x = 60 + Math.cos(a) * 32;
      const y = 60 + Math.sin(a) * 32;
      return (
        <g key={i}>
          <ellipse cx={x} cy={y} rx="14" ry="8" transform={`rotate(${(i * 45)} ${x} ${y})`} />
          <circle cx={x} cy={y} r="2" fill={stroke} />
        </g>
      );
    })}
    <circle cx="60" cy="60" r="52" strokeDasharray="3 4" />
    <circle cx="60" cy="60" r="58" />
  </svg>
);

export const CornerVine = ({ className = "", stroke = "#b8452c", size = 90 }) => (
  <svg viewBox="0 0 100 100" width={size} height={size} className={className} fill="none" stroke={stroke} strokeWidth="1.4">
    <path d="M2 98 Q 30 70 50 50 T 98 2" />
    <path d="M2 98 Q 50 90 70 70 T 98 40" strokeDasharray="2 4" />
    <circle cx="25" cy="75" r="3" fill={stroke} />
    <circle cx="50" cy="50" r="3" fill={stroke} />
    <circle cx="75" cy="25" r="3" fill={stroke} />
    <path d="M40 60 q 6 -2 8 -8 q -8 0 -8 8 Z" fill={stroke} opacity="0.7" />
    <path d="M60 40 q 6 -2 8 -8 q -8 0 -8 8 Z" fill={stroke} opacity="0.7" />
  </svg>
);

export const DiamondBorder = ({ className = "" }) => (
  <div className={`flex items-center gap-3 ${className}`}>
    <span className="h-px flex-1 bg-[var(--terracotta)] opacity-40" />
    <svg width="48" height="14" viewBox="0 0 48 14" fill="none">
      <path d="M6 7 L12 1 L18 7 L12 13 Z" stroke="#b8452c" strokeWidth="1.2" />
      <path d="M20 7 L24 3 L28 7 L24 11 Z" fill="#b8452c" />
      <path d="M30 7 L36 1 L42 7 L36 13 Z" stroke="#b8452c" strokeWidth="1.2" />
    </svg>
    <span className="h-px flex-1 bg-[var(--terracotta)] opacity-40" />
  </div>
);

// export const SectionLabel = ({ children }) => (
//   <div className="inline-flex items-center gap-3 rounded-full border border-[var(--terracotta)]/30 bg-white/60 px-4 py-1.5 backdrop-blur-sm">
//     <span className="h-1.5 w-1.5 rounded-full bg-[var(--terracotta)]" />
//     <span className="font-serif text-sm tracking-[0.2em] uppercase text-[var(--terracotta-deep)]">{children}</span>
//     <span className="h-1.5 w-1.5 rounded-full bg-[var(--saffron)]" />
//   </div>
// );
export const SectionLabel = ({ children }) => (
  <div className="inline-flex items-center gap-3 rounded-full
    border border-[#17324D]
    bg-[#17324D]
    px-4 py-1.5
    shadow-[0_6px_20px_rgba(23,50,77,0.25)]">

    <span className="h-1.5 w-2 rounded-full bg-[#F4A340]" />

    <span className="font-serif text-base md:text-lg font-bold
      tracking-[0.18em] uppercase text-white">
      {children}
    </span>

    <span className="h-1.5 w-2 rounded-full bg-[#C54B32]" />

  </div>
);